export default __webpack_public_path__ + "static/media/lightbulb.c7c6dd00.svg";